export const SETTING_UPDATE_SUCCESS = "SETTING_UPDATE_SUCCESS";
export const SETTING_UPDATE_FAILED = "SETTING_UPDATE_FAILED";

export const SETTING_ITEM_SUCCESS = "SETTING_ITEM_SUCCESS";
export const SETTING_ITEM_FAILED = "SETTING_ITEM_FAILED";

export const SETTING_RESET_SUCCESS = "SETTING_RESET_SUCCESS";



